
 App.directive('appFilewebdav', function(){
    'use strict';
  
    return {
        templateUrl: '/app/views/partials/filewebdav.html',
        controller: 'FileWebdavController',
        restrict: 'E',
        replace: true,
        scope: {
          file: '=file'
        }
    };
  
  });